import { render, staticRenderFns } from "./DetailProgram.vue?vue&type=template&id=db1b14e4&scoped=true&"
import script from "./DetailProgram.vue?vue&type=script&lang=js&"
export * from "./DetailProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1b14e4",
  null
  
)

export default component.exports